module.exports = __webpack_public_path__ + "media/favicon/mstile-70x70-9c5df357a944fe758bee4a7672a8650b.png";